import { render } from "./category manage.vue?vue&type=template&id=ce0e4fda"
import script from "./category manage.vue?vue&type=script&lang=js"
export * from "./category manage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__